module.exports = __webpack_public_path__ + "images/Ciso.c666e514.webp";